import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
  createRiskCategoryDistribution,
  getCategoryColor,
} from "../../lib/riskAnalytics";

const RiskCategoryDistribution = ({
  risks,
  title = "Risk Categories",
  className,
}) => {
  const distributionData = createRiskCategoryDistribution(risks);

  if (distributionData.totalRisks === 0) {
    return (
      <Card className={className}>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center py-8">
            <p className="text-muted-foreground">
              No risks available to display category distribution
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {/* Visual Bar Chart */}
        <div className="space-y-2">
          {distributionData.distribution.map((item, index) => (
            <div key={item.category} className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground truncate">
                  {item.category}
                </span>
                <span className="text-muted-foreground">
                  {item.count} ({item.percentage}%)
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${getCategoryColor(index)}`}
                  style={{ width: `${item.percentage}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default RiskCategoryDistribution;
